import { useCrmUrl } from '@/utils/crm-url';

type DonorFertilizationLinkProps = {
  fertilizationId: string;
  donorName: string;
};

export const DonorFertilizationLink = ({
  fertilizationId,
  donorName,
}: DonorFertilizationLinkProps) => {
  const crmUrl = useCrmUrl();
  if (!crmUrl) {
    return donorName;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10017');
  url.searchParams.set(
    'extraqs',
    'formid=b8caab64-5324-4038-808b-7fe7fb6a57af',
  );
  url.searchParams.set('id', `{${fertilizationId}}`);
  url.searchParams.set('pagetype', 'entityrecord');
  url.hash = '398806900';

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {donorName}
    </a>
  );
};
